import { Link } from 'react-router-dom';
import SeoMeta from '@/components/base/SeoMeta';

export default function NotFound() {
  return (
    <>
      <SeoMeta
        title="页面不存在 - 真相回旋镖"
        description="你访问的页面不存在或已被移动，请返回首页或反转档案继续浏览。"
        path="/"
      />
      <section className="mx-auto flex w-full flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="font-heading text-6xl font-bold text-primary-500 md:text-7xl">404</span>
        <h1 className="mt-6 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          这条线索走丢了
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
          你要找的页面不存在，或者链接已经被改写过。不妨回到反转档案，再挑一条你关心的案例看看。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/"
            className="flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/archive"
            className="flex items-center justify-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 text-sm font-label text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-folder-open-line" aria-hidden="true" />
            浏览反转档案
          </Link>
        </div>
      </section>
    </>
  );
}